module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-16.66fea75a.png";